export enum PageType {
  EDIT = 'edit',
  CREATE = 'create',
  VIEW = 'view',
  LIST = 'list',
}
